<template>
  <div id="app">
    <el-container v-if="$route.path!=='/login' && $route.path!=='/'"  style="height: 100%;" direction="vertical">
      <el-header height="60px">
        <div id="img" style="text-align: left;width: 100%;height:5px;margin-left: 0%;">
<!--          <el-image :src="url" :lazy="true"  class="imgestype"></el-image>-->
        </div>
        <div id="user" style="text-align: right;width: 100%;height:50px;margin-left: 0%;">
          <el-dropdown @command="handleCommand">
            <span class="el-dropdown-link">
              <!--<el-popconfirm  title="确定退出？" @confirm="logout()">
                <el-avatar :size="50" slot="reference">{{userName}}</el-avatar>
              </el-popconfirm>-->
              <el-avatar :size="50" name="eng" slot="reference">{{userName}}</el-avatar>
            </span>
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item command="edit"><i class="el-icon-edit"></i>修改密码</el-dropdown-item>
              <el-dropdown-item command="logout"><i class="el-icon-bottom-left"></i>退出系统</el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
        </div>
      </el-header>
      <el-container>
        <!-- 侧边导航菜单 -->
        <el-aside width="150px">
          <template>
            <div class="left">
              <el-menu
                default-active="0-1"
                class="el-menu-vertical-demo"
                style="pading-top:10px"
                @open="handleOpen"
                @close="handleClose"
                background-color="#778DA9"
                text-color="#030303"
                active-text-color="#030303">
                <sideMenu :data="menu_data"></sideMenu>
              </el-menu>
            </div>
          </template>
        </el-aside>
        <!-- 内容 -->
        <el-main>
          <router-view/>
        </el-main>
      </el-container>
    </el-container>
    <el-container v-if="$route.path =='/login' || $route.path =='/'">
      <router-view/>
    </el-container>
  </div>
</template>

<script>
import sideMenu from "./components/template/SideMenu";
import {HttpResp} from './constant/index';
import {loginApi, sysApi} from './api/index';

export default {
  name: 'App',
  components: {sideMenu},
  created(){
    window.addEventListener('setItem', ()=> {
      this.userName = localStorage.getItem('userName');
    })
  },
  data() {
    return {
      userName: localStorage.getItem("userName"),
      menu_data: {},
    }
  },
  mounted() {
    this.getMenuList();
  },
  methods: {
    jumpPage(page) {
      //用vue路由跳转到后台主界面
      this.$router.push({path: page});
    },
    handleOpen(key, keyPath) {
      //console.log(key, keyPath);
    },
    handleClose(key, keyPath) {
      console.log(key, keyPath);
    },
    logout() {
      //调用函数  传递参数 获取结果
      loginApi.logout().then(data => {
        if (data.code == HttpResp.SUCCUSS) {
          //退出
          //用vue路由跳转登入页面
          this.$router.push("/login");
        } else {
          this.$message({
            message: data.message,
            type: 'error'
          });
        }
      });
    },
    getMenuList() {
      //当页面为登入页面的时候不加载菜单（未登入的时候不加载菜单）
      let path = this.$route.path;
      if(path === '/login' || path === '/'){
        return;
      }
      sysApi.myMenu().then(data => {
        if (data.code == HttpResp.SUCCUSS) {
          this.menu_data = data.data.menuTreeList;
        } else {
          this.$message({
            message: data.message,
            type: 'error'
          });
        }
      });
    },
    handleCommand(command) {
      if("edit" === command){
        this.$router.push({path:'/EditPwd'});
      }else if("logout" === command){
        this.logout();
      }
    },
    pathChange(path) {
      if(path == "/login")
        //如果是从登入页面过来的，则重新执行菜单加载
        console.log("登入成功，重新加载菜单");
        this.getMenuList();
    },
  },
  watch: {
    // 如果路由有变化，会再次执行pathChange方法
    $route(to , from){
      //console.error( '去：',to.path,'来自：', from.path );
      this.pathChange(from.path);
    }
  },
}
</script>

<style>
  #app {
    font-family: 'Avenir', Helvetica, Arial, sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    text-align: center;
    width:100%;
    color: #2c3e50;
    margin-top: 0px;
    height: 100%; padding: 60px 0 0; box-sizing: border-box ; position: relative;
  }
  html,
  body {
    background: #F4F4F9;
    height: 100%; padding: 0; margin: 0;
   }
  .imgestype {
    width: 60px;
    height: 60px;
  }
  .el-header {
    background-color: #1B263B;
    position: absolute; top: 0 ; left: 0 ; width: 100%;
  }
  .el-aside {
    background-color: #778DA9;
  }
  .el-footer {
    background-color: #909399;
    color: black;
    text-align: center;
  }
  .el-submenu__title{
    font-size: 14px;
  }
  .el-menu{
    border-right-width: 0px;
  }
  .el-menu-item{
    font-size: 14px;
  }
  .el-icon-s-home:before {
    color: #909399;
    margin-right: 15px;
  }
  /*按钮大小*/
  .el-button{
    padding: 7px 10px;
  }
  /*文本框*/
  .el-input__inner {
    height: 35px;
  }
  .el-main{
    padding: 15px;
  }
  /*表单行间距*/
  .el-form-item {
    margin-bottom: 15px;
  }
  /*表格行间距*/
  .el-table td, .el-table th {
    padding: 10px 0;
  }
 /* 查询表单的操作按钮定义，样式需要手动加上  <el-button class="el-form-button" >新增</el-button>*/
  .el-form-button{
    width: 65px;
    height: 35px;
  }

  /*滚动条的宽度*/
  ::-webkit-scrollbar {
    width: 5px;
    height: 10px;
  }
  /*滚动条的滑块*/
  ::-webkit-scrollbar-thumb {
    background-color:#dddddd;
    border-radius: 2px;
  }
</style>



// WEBPACK FOOTER //
// src/App.vue